import type { NodeDefinition } from '@shared/types/node-definition';

const definition: NodeDefinition = {
  type: 'langchain-prompt-template',
  name: 'LangChain Prompt Template',
  description: 'Create reusable prompt templates with variable placeholders',
  icon: 'FileCode',
  color: 'purple',
  category: 'ai-nodes',
  tags: ['langchain', 'prompt', 'template', 'ai', 'llm'],
  comingSoon: true,
  version: '1.0.0',
  inputs: [],
  outputs: [],
};

export default definition;
